import { useState, useMemo } from "react";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from "@mui/material/TablePagination";

const DataTable = ({
  columns = [],
  data = [],
  page = 0,
  rowsPerPage = 5,
  totalCount = null,
  onPageChange,
  onRowsPerPageChange,
  onRowClick
}) => {
  const [clientSidePage, setClientSidePage] = useState(0);
  const [clientSideRowsPerPage, setClientSideRowsPerPage] = useState(10);

  const safeData = Array.isArray(data) ? data : [];
  const safeColumns = Array.isArray(columns) ? columns : [];

  const isClientSidePagination = totalCount === null;

  const paginatedData = useMemo(() => {
    if (!isClientSidePagination) {
      return safeData;
    }
    return safeData.slice(
      clientSidePage * clientSideRowsPerPage,
      (clientSidePage + 1) * clientSideRowsPerPage
    );
  }, [safeData, isClientSidePagination, clientSidePage, clientSideRowsPerPage]);

  const handlePageChange = (event, newPage) => {
    if (isClientSidePagination) {
      setClientSidePage(newPage);
    } else {
      onPageChange?.(event, newPage);
    }
  };

  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    if (isClientSidePagination) {
      setClientSideRowsPerPage(newRowsPerPage);
      setClientSidePage(0);
    } else {
      onRowsPerPageChange?.(event);
    }
  };

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="dynamic table">
        <TableHead>
          <TableRow>
            {safeColumns.map((col, index) => (
              <TableCell key={index} align="left">
                {col.label}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>
          {paginatedData.map((row, rowIndex) => (
            <TableRow
              key={rowIndex}
              onClick={() => onRowClick?.(row)}
              hover
              sx={{ cursor: 'pointer' }}
            >
              {safeColumns.map((col, colIndex) => (
                <TableCell key={colIndex} align="left">
                  {row[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <TablePagination
        component="div"
        count={isClientSidePagination ? safeData.length : totalCount}
        page={isClientSidePagination ? clientSidePage : page}
        onPageChange={handlePageChange}
        rowsPerPage={isClientSidePagination ? clientSideRowsPerPage : rowsPerPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        rowsPerPageOptions={[20, 40, 50, 100]}
      />
    </TableContainer>
  );
};

export default DataTable;